var _rect, _rect2, _ellipse, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 7,
    fill: "#9D7022"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13.625,
    width: 22.75,
    height: 22.75,
    rx: 5.25,
    fill: "#FFE39C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.875,
    cy: 19.6875,
    rx: 6.125,
    ry: 5.6875,
    fill: "url(#paint0_linear_1685_627)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.517 35.0748C10.4161 35.2106 10.4444 35.4024 10.5802 35.5033C10.7159 35.6042 10.9078 35.5759 11.0086 35.4401L10.517 35.0748ZM17.3013 26.4568L17.5458 26.2725L17.2995 25.9456L17.0554 26.2742L17.3013 26.4568ZM21.7695 32.3864L21.5249 32.5707L21.7437 32.861L21.9927 32.5961L21.7695 32.3864ZM34.2375 19.1175L30.8519 20.1385L33.429 22.56L34.2375 19.1175ZM11.0086 35.4401L17.5471 26.6395L17.0554 26.2742L10.517 35.0748L11.0086 35.4401ZM17.0567 26.6411L21.5249 32.5707L22.0141 32.2021L17.5458 26.2725L17.0567 26.6411ZM21.9927 32.5961L32.5733 21.3358L32.1269 20.9164L21.5463 32.1767L21.9927 32.5961Z",
    fill: "#9D7022"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1685_627",
    x1: 33.875,
    y1: 14,
    x2: 33.875,
    y2: 25.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuIcon);
export default __webpack_public_path__ + "static/media/dashboardMenuIcon.ba7f931edd5831e7c09a2c2c097a1944.svg";
export { ForwardRef as ReactComponent };